module.exports = __webpack_public_path__ + "static/media/stegato_screenshot.5e721fe7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stegato_screenshot.jpg
// module id = 555
// module chunks = 0